import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { TypeMobileDisplay01, TypeDesktopDisplay01, TypeMobileDisplay02, TypeDesktopDisplay02, TypeMobileDisplay03, TypeDesktopDisplay03, TypeMobileDisplay04, TypeDesktopDisplay04, TypeMobileDisplay05, TypeDesktopDisplay05, TypeMobileDisplay06, TypeDesktopDisplay06, TypeMobileBodyLead, TypeDesktopBodyLead, TypeMobileBodyText, TypeDesktopBodyText, TypeMobileBodyCaption, TypeDesktopBodyCaption, TypeMobileBodyLabel, TypeDesktopBodyLabel, TypeMobileButtonLabel, TypeDesktopButtonLabel, TypeMobileButtonUnderlined, TypeDesktopButtonUnderlined, TypeMobileButtonTextLink, TypeDesktopButtonTextLink, ColorPrimary01, ColorPrimary02, ColorPrimary03, ColorBlack00, ColorBlack05, ColorBlack10, ColorBlack20, ColorBlack30, ColorBlack40, ColorBlack50, ColorBlack60, ColorBlack70, ColorBlack80, ColorBlack90, ColorBlack100, ColorTextHeadline, ColorTextBody, ColorTextInverted, ColorTextAlternate, ColorTextLabel, ColorInteractionDefault, ColorInteractionHoverState, ColorInteractionFocusState, ColorInteractionButton, ColorInteractionButtonHover, ColorInteractionButtonFocus, ColorInteractionControl, ColorInteractionControlHoverFill, ColorInteractionDeactivated, ColorInteractionFocusIndicator, ColorInteractionIcon, ColorInteractionIconHover, ColorInteractionIconFavourite, ColorInteractionLoading, ColorInteractionSelectedState, ColorInteractionSelectedStateHover, ColorInteractionTextLink, ColorInteractionTextLinkHover, ColorInteractionTextLinkFocus, ColorInteractionBackgroundHover, ColorFeedbackSuccess, ColorFeedbackError, ColorFeedbackInformation, ColorFeedbackWarning, ColorFeedbackRating, ColorBackgroundSelectedState, ColorBackgroundSuccess, ColorBackgroundDeactivated, ColorBackgroundError, ColorBackgroundInformation, ColorBackgroundWarning, ColorBackgroundHoverState, ColorBackground01, ColorBackground02, ColorBackground03, ColorBackground04, ColorBackground05, ColorBackground06, ColorBackground07, ColorBackgroundHero, ColorBackgroundBranded, ColorBackgroundSite, ColorBorder01, ColorBorder02, ColorBorder03, ColorBorder04, ColorPillSponsored, ColorPillMembership, ColorPillEco, ColorPillMarketing, ColorPillUsp, ColorPillPrice, SpacingNone, Spacing01, Spacing02, Spacing03, Spacing04, Spacing05, Spacing06, Spacing07, Spacing08, Spacing09, Spacing10, Spacing11, Spacing12, Spacing13, Spacing14, Spacing15, Spacing16, BorderRadiusSelector, BorderRadiusChip, BorderRadius00, BorderRadius01, BorderRadius02, BorderRadius03, BorderRadius04, BorderRadius05, BorderRadius06, BorderRadiusCircle, BorderWidth01, BorderWidth02, BorderWidth03, BorderWidth04, BorderWidth05, BorderWidth06, BorderWidthSelectorDefault, BorderWidthSelectorHover, BorderWidthSelectorSelected, BoxShadow00, BoxShadow01, BoxShadow02, BoxShadow03, BoxShadow04, BoxShadowFocus, SizeIconSmall, SizeIconMedium, SizeIconLarge, SizeTouchSquare } from '@moonpig/launchpad-design-tokens/moonpig';

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

// eslint-disable-next-line @typescript-eslint/no-explicit-any

var createResponsiveType = function createResponsiveType(_ref) {
  var xs = _ref.xs,
    md = _ref.md;
  var xsOut = _objectSpread$1({}, xs);
  var mdOut = _objectSpread$1({}, md);
  var topLevel = {};
  Object.keys(xs).forEach(function (key) {
    var k = key;
    if (md[k] === xs[k]) {
      topLevel[k] = xs[k];
      delete xsOut[k];
      delete mdOut[k];
    }
  });
  var map = _objectSpread$1(_objectSpread$1({}, Object.keys(xsOut).length > 0 ? {
    xs: xsOut
  } : {}), Object.keys(mdOut).length > 0 ? {
    md: mdOut
  } : {});
  return _objectSpread$1(_objectSpread$1({}, topLevel), Object.keys(map).length > 0 ? {
    map: map
  } : {});
};
var typography = {
  // top level tokens
  typeMobileDisplay01: TypeMobileDisplay01,
  typeDesktopDisplay01: TypeDesktopDisplay01,
  typeMobileDisplay02: TypeMobileDisplay02,
  typeDesktopDisplay02: TypeDesktopDisplay02,
  typeMobileDisplay03: TypeMobileDisplay03,
  typeDesktopDisplay03: TypeDesktopDisplay03,
  typeMobileDisplay04: TypeMobileDisplay04,
  typeDesktopDisplay04: TypeDesktopDisplay04,
  typeMobileDisplay05: TypeMobileDisplay05,
  typeDesktopDisplay05: TypeDesktopDisplay05,
  typeMobileDisplay06: TypeMobileDisplay06,
  typeDesktopDisplay06: TypeDesktopDisplay06,
  typeMobileBodyLead: TypeMobileBodyLead,
  typeDesktopBodyLead: TypeDesktopBodyLead,
  typeMobileBodyText: TypeMobileBodyText,
  typeDesktopBodyText: TypeDesktopBodyText,
  typeMobileBodyCaption: TypeMobileBodyCaption,
  typeDesktopBodyCaption: TypeDesktopBodyCaption,
  typeMobileBodyLabel: TypeMobileBodyLabel,
  typeDesktopBodyLabel: TypeDesktopBodyLabel,
  typeMobileButtonLabel: TypeMobileButtonLabel,
  typeDesktopButtonLabel: TypeDesktopButtonLabel,
  typeMobileButtonUnderlined: TypeMobileButtonUnderlined,
  typeDesktopButtonUnderlined: TypeDesktopButtonUnderlined,
  typeMobileButtonTextLink: TypeMobileButtonTextLink,
  typeDesktopButtonTextLink: TypeDesktopButtonTextLink,
  // responsive types
  typeDisplay01: createResponsiveType({
    xs: TypeMobileDisplay01,
    md: TypeDesktopDisplay01
  }),
  typeDisplay02: createResponsiveType({
    xs: TypeMobileDisplay02,
    md: TypeDesktopDisplay02
  }),
  typeDisplay03: createResponsiveType({
    xs: TypeMobileDisplay03,
    md: TypeDesktopDisplay03
  }),
  typeDisplay04: createResponsiveType({
    xs: TypeMobileDisplay04,
    md: TypeDesktopDisplay04
  }),
  typeDisplay05: createResponsiveType({
    xs: TypeMobileDisplay05,
    md: TypeDesktopDisplay05
  }),
  typeDisplay06: createResponsiveType({
    xs: TypeMobileDisplay06,
    md: TypeDesktopDisplay06
  }),
  typeBodyLead: createResponsiveType({
    xs: TypeMobileBodyLead,
    md: TypeDesktopBodyLead
  }),
  typeBodyText: createResponsiveType({
    xs: TypeMobileBodyText,
    md: TypeDesktopBodyText
  }),
  typeBodyCaption: createResponsiveType({
    xs: TypeMobileBodyCaption,
    md: TypeDesktopBodyCaption
  }),
  typeBodyLabel: createResponsiveType({
    xs: TypeMobileBodyLabel,
    md: TypeDesktopBodyLabel
  }),
  typeButtonLabel: createResponsiveType({
    xs: TypeMobileButtonLabel,
    md: TypeDesktopButtonLabel
  }),
  typeButtonUnderlined: createResponsiveType({
    xs: TypeMobileButtonUnderlined,
    md: TypeDesktopButtonUnderlined
  }),
  typeButtonTextLink: createResponsiveType({
    xs: TypeMobileButtonTextLink,
    md: TypeDesktopButtonTextLink
  })
  // eslint-disable-next-line prettier/prettier
};

var colorValue = function colorValue(color) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.colors[color];
  };
};
var spacing$1 = function spacing(value) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.spacing[value];
  };
};
var spacingPx = function spacingPx(value) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return "".concat(spacing$1(value)({
      theme: theme
    }), "px");
  };
};

var breakpointMap = {
  xs: 0,
  sm: 400,
  md: 640,
  lg: 900,
  xl: 1200,
  xxl: 1640
};

var colors = {
  colorPrimary01: ColorPrimary01,
  colorPrimary02: ColorPrimary02,
  colorPrimary03: ColorPrimary03,
  colorBlack00: ColorBlack00,
  colorBlack05: ColorBlack05,
  colorBlack10: ColorBlack10,
  colorBlack20: ColorBlack20,
  colorBlack30: ColorBlack30,
  colorBlack40: ColorBlack40,
  colorBlack50: ColorBlack50,
  colorBlack60: ColorBlack60,
  colorBlack70: ColorBlack70,
  colorBlack80: ColorBlack80,
  colorBlack90: ColorBlack90,
  colorBlack100: ColorBlack100,
  colorTextHeadline: ColorTextHeadline,
  colorTextBody: ColorTextBody,
  colorTextInverted: ColorTextInverted,
  colorTextAlternate: ColorTextAlternate,
  colorTextLabel: ColorTextLabel,
  colorInteractionDefault: ColorInteractionDefault,
  colorInteractionHoverState: ColorInteractionHoverState,
  colorInteractionFocusState: ColorInteractionFocusState,
  colorInteractionButton: ColorInteractionButton,
  colorInteractionButtonHover: ColorInteractionButtonHover,
  colorInteractionButtonFocus: ColorInteractionButtonFocus,
  colorInteractionControl: ColorInteractionControl,
  colorInteractionControlHoverFill: ColorInteractionControlHoverFill,
  colorInteractionDeactivated: ColorInteractionDeactivated,
  colorInteractionFocusIndicator: ColorInteractionFocusIndicator,
  colorInteractionIcon: ColorInteractionIcon,
  colorInteractionIconHover: ColorInteractionIconHover,
  colorInteractionIconFavourite: ColorInteractionIconFavourite,
  colorInteractionLoading: ColorInteractionLoading,
  colorInteractionSelectedState: ColorInteractionSelectedState,
  colorInteractionSelectedStateHover: ColorInteractionSelectedStateHover,
  colorInteractionTextLink: ColorInteractionTextLink,
  colorInteractionTextLinkHover: ColorInteractionTextLinkHover,
  colorInteractionTextLinkFocus: ColorInteractionTextLinkFocus,
  colorInteractionBackgroundHover: ColorInteractionBackgroundHover,
  colorFeedbackSuccess: ColorFeedbackSuccess,
  colorFeedbackError: ColorFeedbackError,
  colorFeedbackInformation: ColorFeedbackInformation,
  colorFeedbackWarning: ColorFeedbackWarning,
  colorFeedbackRating: ColorFeedbackRating,
  colorBackgroundSelectedState: ColorBackgroundSelectedState,
  colorBackgroundSuccess: ColorBackgroundSuccess,
  colorBackgroundDeactivated: ColorBackgroundDeactivated,
  colorBackgroundError: ColorBackgroundError,
  colorBackgroundInformation: ColorBackgroundInformation,
  colorBackgroundWarning: ColorBackgroundWarning,
  colorBackgroundHoverState: ColorBackgroundHoverState,
  colorBackground01: ColorBackground01,
  colorBackground02: ColorBackground02,
  colorBackground03: ColorBackground03,
  colorBackground04: ColorBackground04,
  colorBackground05: ColorBackground05,
  colorBackground06: ColorBackground06,
  colorBackground07: ColorBackground07,
  colorBackgroundHero: ColorBackgroundHero,
  colorBackgroundBranded: ColorBackgroundBranded,
  colorBackgroundSite: ColorBackgroundSite,
  colorBorder01: ColorBorder01,
  colorBorder02: ColorBorder02,
  colorBorder03: ColorBorder03,
  colorBorder04: ColorBorder04,
  colorPillSponsored: ColorPillSponsored,
  colorPillMembership: ColorPillMembership,
  colorPillEco: ColorPillEco,
  colorPillMarketing: ColorPillMarketing,
  colorPillUSP: ColorPillUsp,
  colorPillPrice: ColorPillPrice
};

var spacing = [SpacingNone, Spacing01, Spacing02, Spacing03, Spacing04, Spacing05, Spacing06, Spacing07, Spacing08, Spacing09, Spacing10, Spacing11, Spacing12, Spacing13, Spacing14, Spacing15, Spacing16];

var baseScale$2 = [BorderRadius00, BorderRadius01, BorderRadius02, BorderRadius03, BorderRadius04, BorderRadius05, BorderRadius06, BorderRadiusCircle];
var radii = Object.assign([].concat(baseScale$2), {
  // aliases
  borderRadiusNone: baseScale$2[0],
  borderRadius01: baseScale$2[1],
  borderRadius02: baseScale$2[2],
  borderRadius03: baseScale$2[3],
  borderRadius04: baseScale$2[4],
  borderRadius05: baseScale$2[5],
  borderRadius06: baseScale$2[6],
  borderRadiusCircle: baseScale$2[7],
  // semantic
  borderRadiusSelector: BorderRadiusSelector,
  borderRadiusChip: BorderRadiusChip
});

var baseScale$1 = ['none', "".concat(BorderWidth01, " solid"), "".concat(BorderWidth02, " solid"), "".concat(BorderWidth03, " solid"), "".concat(BorderWidth04, " solid"), "".concat(BorderWidth05, " solid"), "".concat(BorderWidth06, " solid")];
var borders = Object.assign([].concat(baseScale$1), {
  // aliases
  borderNone: 'none',
  border01: "".concat(BorderWidth01, " solid"),
  border02: "".concat(BorderWidth02, " solid"),
  border03: "".concat(BorderWidth03, " solid"),
  border04: "".concat(BorderWidth04, " solid"),
  border05: "".concat(BorderWidth05, " solid"),
  border06: "".concat(BorderWidth06, " solid"),
  // semantic
  borderWidthSelectorDefault: "".concat(BorderWidthSelectorDefault, " solid"),
  borderWidthSelectorHover: "".concat(BorderWidthSelectorHover, " solid"),
  borderWidthSelectorSelected: "".concat(BorderWidthSelectorSelected, " solid")
});

var baseScale = [BoxShadow00, BoxShadow01, BoxShadow02, BoxShadow03, BoxShadow04, BoxShadowFocus];
var shadows = Object.assign([].concat(baseScale), {
  // aliases
  boxShadow00: BoxShadow00,
  boxShadow01: BoxShadow01,
  boxShadow02: BoxShadow02,
  boxShadow03: BoxShadow03,
  boxShadow04: BoxShadow04,
  boxShadow05: BoxShadowFocus,
  // semantic
  boxShadowFocus: BoxShadowFocus
});

var BASE_FONT_SIZE = 16;

var sizeIcon = {
  iconSmall: SizeIconSmall,
  iconMedium: SizeIconMedium,
  iconLarge: SizeIconLarge
};
var sizeTouch = {
  touchSquare: SizeTouchSquare
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

// Font types

var baseTheme = {
  baseFontSize: BASE_FONT_SIZE,
  spacing: spacing,
  shadows: shadows,
  breakpoints: {
    map: breakpointMap,
    keys: Object.keys(breakpointMap),
    up: function up(key) {
      return "@media (min-width: ".concat(breakpointMap[key] / BASE_FONT_SIZE, "em)");
    },
    down: function down(key) {
      return "@media (max-width: ".concat(breakpointMap[key] / BASE_FONT_SIZE - 0.01, "em)");
    }
  },
  radii: radii,
  borders: borders,
  siteWidth: 1200,
  richTextWidth: 600,
  size: _objectSpread(_objectSpread({}, sizeIcon), sizeTouch)
};

// TO DELETE ONCE MOONPIG WEB USING @moonpig/launchpad-theme-moonpig
var theme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: colors,
  // Nb. @material-ui/system currently looks for 'palette' on theme
  // This may change in https://github.com/mui-org/material-ui/issues/13663
  // at which point we could drop this alias
  palette: colors,
  typography: typography,
  fontFaces: []
});

export { BASE_FONT_SIZE, baseTheme, colorValue, createResponsiveType, spacing$1 as spacing, spacingPx, theme };
